// @ts-nocheck
// oxlint-disable no-unused-vars
import type { ApiResponseOfFeedbackDto, FeedbackRequest } from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * POST `/feedback`
 */
export const postApiFeedback = (data: FeedbackRequest) =>
	apiFetch<ApiResponseOfFeedbackDto>({
		uri: "feedback",
		method: "POST",
		body: data,
	});
